// TransactionDefaultTable.tsx
import React from "react";
import { numberWithCommas } from "../../../utils/customFunction";

interface TransactionDefaultTableProps {
  dropdownList: any[];
  selectedValues: any;
  reportTxn: any[];
  itemsToShow: number;
  renderDropdownValues: (
    index: number,
    selectedCol: any,
    transaction: any,
  ) => any;
  distName: any;
  totals: {
    totalNetAmount: string;
    totalGrossAmount: string;
    totalSaleLoad: string;
    totalCGT: string;
    totalRedemptionLoad: string;
    totalUnits: string;
    totalCurrentHolding: string;
    totalZakatAmount: string;
    totalWHT_II: string;
    totalWHT_SST: string;
    totalTax_SST: string;
    totalTotalAmount: string;
    totalTotalTaxItBonusAmount: string;
    totalTotatNetBonusVolume: string;
    totalRightShareGrossVolume: string;
    totalTaxITRightShareAmount: string;
    totalNetRightShareVolume: string;
  };
}

export const TransactionDefaultTable: React.FC<
  TransactionDefaultTableProps
> = ({
  dropdownList,
  selectedValues,
  reportTxn,
  itemsToShow,
  renderDropdownValues,
  distName,
  totals,
}) => {
  return (
    <div style={{ overflowX: "auto", overflowY: "hidden" }}>
      <table className="report" style={{ color: "black" }}>
        <thead style={{ alignSelf: "center" }}>
          <tr>
            {dropdownList?.map((item: any, index: number) => {
              if (selectedValues?.columns?.includes(item?.label)) {
                return (
                  <th key={index}>
                    <span
                      className="htmltoPdfStyle"
                      id="test"
                      style={{ textTransform: "capitalize" }}
                    >
                      {item.label.toString()}
                    </span>
                  </th>
                );
              }
              return null;
            })}
          </tr>
        </thead>

        <tbody className="report-table-body">
          {reportTxn
            ?.slice(0, itemsToShow)
            .map((transaction: any, index: number) => (
              <tr key={index}>
                {dropdownList?.map((item: any, i: number) => {
                  if (selectedValues?.columns?.includes(item?.label)) {
                    return (
                      <td className="htmltoPdfStyle" id="test" key={i}>
                        {renderDropdownValues(index + 1, item, transaction)}
                      </td>
                    );
                  }
                  return null;
                })}
              </tr>
            ))}
        </tbody>

        {distName !== "nccpl" && (
          <tfoot>
            <tr>
              {dropdownList?.map((item: any, idx: number) => {
                if (!selectedValues?.columns?.includes(item?.label))
                  return null;

                let val = "";
                if (item.value === "net_amount") val = totals.totalNetAmount;
                else if (item.value === "gross_amount")
                  val = totals.totalGrossAmount;
                else if (item.value === "sale_load") val = totals.totalSaleLoad;
                else if (item.value === "tax_cgt") val = totals.totalCGT;
                else if (item.value === "redemption_load")
                  val = totals.totalRedemptionLoad;
                else if (item.value === "units") val = totals.totalUnits;
                else if (item.value === "current_holding")
                  val = totals.totalCurrentHolding;
                else if (item.value === "zakat_amount")
                  val = totals.totalZakatAmount;
                else if (item.value === "tax_wht_it") val = totals.totalWHT_II;
                else if (item.value === "tax_wht_sst")
                  val = totals.totalWHT_SST;
                else if (item.value === "tax_sst") val = totals.totalTax_SST;
                else if (item.value === "total_charges")
                  val = totals.totalTotalAmount;
                else if (item.value === "tax_it_bonus_amount")
                  val = totals.totalTotalTaxItBonusAmount;
                else if (item.value === "net_bonus_volume")
                  val = totals.totalTotatNetBonusVolume;
                else if (item.value === "right_share_gross_volume")
                  val = totals.totalRightShareGrossVolume;
                else if (item.value === "tax_it_right_share_amount")
                  val = totals.totalTaxITRightShareAmount;
                else if (item.value === "net_right_share_volume")
                  val = totals.totalNetRightShareVolume;

                return (
                  <td className="htmltoPdfStyle" id="test" key={idx}>
                    {val ? numberWithCommas(val) : ""}
                  </td>
                );
              })}
            </tr>
          </tfoot>
        )}
      </table>
    </div>
  );
};

export default TransactionDefaultTable;
